export enum DebugView {
  AUDIO_VIDEO_SETTINGS,
  FEATURE_FLAGS,
  KB_DEBUG,
  SAVE_DATA_IMPORT_EXPORT,
  SAVE_DATA_EDITOR,
  CLICKSTREAM_DEBUG,
  MESSAGES_DEBUG,
}
